import React from 'react';
import { Container } from './ui/Container';
import { Button } from './ui/Button';
import { MoonIcon, ArrowDownIcon } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-20 pb-16 md:pt-32 md:pb-24 overflow-hidden bg-slate-950" data-id="element-64">
      {/* Background decoration */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full max-w-7xl pointer-events-none" data-id="element-65">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-indigo-900/20 rounded-full blur-3xl mix-blend-screen opacity-30 animate-pulse" style={{
        animationDuration: '4s'
      }} data-id="element-66"></div>
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-blue-900/20 rounded-full blur-3xl mix-blend-screen opacity-30" data-id="element-67"></div>
      </div>

      <Container className="relative z-10" data-id="element-68">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16" data-id="element-69">
          {/* Text Content */}
          <div className="flex-1 text-center lg:text-left" data-id="element-70">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-indigo-950/50 border border-indigo-900/50 text-indigo-200 text-sm font-medium mb-6" data-id="element-71">
              <MoonIcon className="w-4 h-4" data-id="element-72" />
              <span data-id="element-73">Para mujeres 50+</span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6" data-id="element-74">
              El problema no es despertar. <br className="hidden lg:block" data-id="element-75" />
              <span className="text-indigo-300 italic" data-id="element-76">
                Es lo que haces después.
              </span>
            </h1>

            <p className="text-lg md:text-xl text-slate-300 mb-8 max-w-2xl mx-auto lg:mx-0 leading-relaxed" data-id="element-77">
              Un guion de 15 minutos para cuando tu mente se prende a las 3AM y
              sientes que ya perdiste la noche.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start" data-id="element-78">
              <Button size="lg" href="#pricing" data-id="element-79">
                Descargar RESET 3AM
              </Button>
              <Button variant="outline" size="lg" href="#problem" data-id="element-80">
                <span className="mr-2" data-id="element-81">Leer más</span>
                <ArrowDownIcon className="w-4 h-4" data-id="element-82" />
              </Button>
            </div>
          </div>

          {/* Image */}
          <div className="flex-1 w-full max-w-lg lg:max-w-none" data-id="element-83">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl shadow-indigo-900/20 border border-slate-800/50 bg-slate-900" data-id="element-84">
              <img src="https://cdn.magicpatterns.com/uploads/p8jjX3jJPcnAG8R7L6aYRj/heylloyd-image-1770710476631.png" alt="RESET 3AM Kit en dispositivos y tarjeta impresa" className="w-full h-auto object-cover" data-id="element-85" />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-950/40 to-transparent pointer-events-none" data-id="element-86"></div>
            </div>
            <p className="text-center text-slate-500 text-sm mt-4 italic" data-id="element-87">
              Incluye versión digital y tarjeta imprimible para la mesita de
              noche
            </p>
          </div>
        </div>
      </Container>
    </section>;
}